export enum ExtraOffersType {
    INITIAL = "initial",
    FOLLOW_UP = "follow_up",
    EXTRA_PAYWALL = "extra_paywall",
}
